export default __webpack_public_path__ + "static/media/GR00033-mentor_amulet_2.b23e1e82.svg";